import React, { useContext } from 'react';
import UserProvider from '../../context/UserContext';
import {useWindowSize} from 'react-use';
import Confetti from 'react-confetti'

const MainSuccess = () => {

    const Data = useContext(UserProvider.context);
    const userData = Data.user

    const {width, height} = useWindowSize();

    return(
        <div className="center-container-holder">
            <Confetti
            width={width}
            height={height}
            drawShape={ctx => {
                ctx.beginPath()
                ctx.fillRect(0, 5, 7, 7);
                ctx.stroke()
                ctx.closePath()
              }}
            />
            <div className="centered-container">
                <div className="center-holder">
                    <div className="rotate">
                         <img src="https://i.ibb.co/524TY6N/infinit-logo.png" alt="" className="infinit-logo slide-right"></img>
                    </div>
                    <div className="success-title-holder">
                        <h1 className="welcome">Welcome to Infinit!</h1>
                    </div>
                    <div className="success-message">
                        <h3 className="success-message-disclaimer">We are processing your order. Your key will be sent to:</h3>
                        <h3 className="bold success-mail">{userData.email}</h3>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default MainSuccess;